import { useMemo } from 'react';
import { resolveLookupOptions } from '@ourbranch/lookups';
import { brandName } from 'brand-config';

/**
 *
 * @param {string} name -- the key in lookupsJson
 * @param {string} state -- the geographical state of the offer/policy being viewed
 * @param {any} currentValue -- the current value of the field
 * @returns array of objects with id, value, and disabled
 *
 * if currentValue is not supplied, hook will return all non-deprecated options
 * if currentValue is supplied, hook will return all non-deprecated options except if the current value is deprecated. In that case, the option will be disabled
 */
const useOptions = (name, state, currentValue = undefined) =>
  useMemo(() => {
    // resolve carrier+state specific options first (build-time brand), then state, then base
    const lookup = resolveLookupOptions(name, state, brandName);

    if (currentValue === undefined || currentValue === null) {
      // show all non deprecated options
      return lookup.filter((opt) => !opt.deprecated);
    }
    // we got a current value
    // if the current value for the field is deprecated, we want to show the option but disable it
    // otherwise the field will be blank
    return lookup
      .filter((opt) => !opt.deprecated || opt.id === currentValue)
      .map((opt) => {
        return { ...opt, disabled: opt.deprecated };
      });
  }, [name, state, currentValue]);

export default useOptions;
